module.exports = __webpack_public_path__ + "img/icon-participants.e324d358.svg";